export default __webpack_public_path__ + "static/media/044-chili pepper.4d348b3e.svg";